import { FOUNDATION } from 'config/features';
import { defineMessage } from 'react-intl';

export const USER_ROLES = {
  ADMIN: 'Admin',
  OPERATOR: 'Operator',
  MONITOR: 'Monitor',
  BILLING: 'Billing',
  DEPLOYER: 'Deployer',
  AGENT: 'Agent',
};

export const OWNER_ROLE = 'Owner';

export const FOUNDATION_OWNER_ORG = 'foundation';

export const USER_ROLES_LABELS = [
  { intl: defineMessage({ id: 'UserConfig-option-admin', defaultMessage: 'Admin' }), value: USER_ROLES.ADMIN },
  { intl: defineMessage({ id: 'UserConfig-option-operator', defaultMessage: 'Operator' }), value: USER_ROLES.OPERATOR },
  { intl: defineMessage({ id: 'UserConfig-option-monitor', defaultMessage: 'Monitor' }), value: USER_ROLES.MONITOR },
  { intl: defineMessage({ id: 'UserConfig-option-billing', defaultMessage: 'Billing' }), value: USER_ROLES.BILLING },
  { intl: defineMessage({ id: 'UserConfig-option-deployer', defaultMessage: 'Deployer' }), value: USER_ROLES.DEPLOYER },
  { intl: defineMessage({ id: 'UserConfig-option-agent', defaultMessage: 'Agent' }), value: USER_ROLES.AGENT },
];

export const isUserOwner = roles => {
  if (FOUNDATION) {
    return roles?.some(
      item => item.organizationDetails?.name === FOUNDATION_OWNER_ORG && item.role === USER_ROLES.ADMIN
    );
  }
  return roles?.some(
    item => (item.organizationId === 1 || item.organizationId === '1') && item.role === USER_ROLES.ADMIN
  );
};

export const isUserAdmin = user => organizationId =>
  user?.roles?.some(item => item.organizationId === organizationId && item.role === USER_ROLES.ADMIN);

const hasRoleInOrganization = (user, organizationId, role) =>
  (user?.roles?.length >= 1 && user.roles.some(item => item.organizationId === organizationId && item.role === role)) ||
  false;

export const isAdmin = user => hasRoleInOrganization(user, user?.organizationId, USER_ROLES.ADMIN);

export const isOperator = user => hasRoleInOrganization(user, user?.organizationId, USER_ROLES.OPERATOR);

export const isOwner = user => {
  if (!user) {
    return false;
  }
  if (FOUNDATION) {
    return (
      user.shortName === FOUNDATION_OWNER_ORG &&
      (user.roles?.some(
        ({ role, organizationDetails }) =>
          organizationDetails?.name === FOUNDATION_OWNER_ORG && role === USER_ROLES.ADMIN
      ) ??
        false)
    );
  }
  return (
    (user.organizationId === 1 || user.organizationId === '1') &&
    (user.roles?.some(
      ({ role, organizationId }) => (organizationId === 1 || organizationId === '1') && role === USER_ROLES.ADMIN
    ) ??
      false)
  );
};

export const isAdminInOrganization = (user, activeRole) =>
  hasRoleInOrganization(user, activeRole?.organizationId, USER_ROLES.ADMIN);

export const isOperatorInOrganization = (user, activeRole) =>
  hasRoleInOrganization(user, activeRole?.organizationId, USER_ROLES.OPERATOR);

export const isDeployerInOrganization = (user, activeRole) =>
  hasRoleInOrganization(user, activeRole?.organizationId, USER_ROLES.DEPLOYER);

export const organizationShortNameOf = activeRole => activeRole?.organizationDetails?.shortName ?? null;

export const deriveActiveRole = (user, storedRole, orgShortNameParam) => {
  if (!user?.roles) {
    return null;
  }
  const defaultOrgId = storedRole ? storedRole.organizationId : user.organizationId;
  return (
    user.roles.find(item => item.organizationDetails?.shortName === orgShortNameParam) ||
    user.roles.find(item => item.organizationId === defaultOrgId) ||
    user.roles.find(item => item.organizationId === user.organizationId) ||
    null
  );
};
